import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AnnoncesComponent } from './annonces/annonces.component';
import { AnnonceReadComponent } from './annonce-read/annonce-read.component';
import { InscriptionComponent } from './inscription/inscription.component';
import {EditPasswordComponent} from "./edit-password/edit-password.component";
import {EditInfosComponent} from "./edit-infos/edit-infos.component";
import {JobalertComponent} from "./jobalert/jobalert.component";
import {EditJobalertComponent} from "./edit-jobalert/edit-jobalert.component";
import { LostPasswordComponent } from './lost-password/lost-password.component';
import { BackProfilComponent } from './back-profil/back-profil.component';
import { AboutComponent } from './about/about.component';
import {
  AuthGuardService as AuthGuard
} from './auth-guard.service';
import { AuthComponent } from './auth/auth.component';


const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'annonces',
    component: AnnoncesComponent
  },
  {
    path: 'inscription',
    component: InscriptionComponent
  },
  {
    path: 'reponse_offre/repoffre_indexation.asp',
    component: InscriptionComponent
  },
  {
    path: 'annonce-read',
    component: AnnonceReadComponent
  },
  {
    path: 'annonce-read/:id',
    component: AnnonceReadComponent
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'profil',
    component: BackProfilComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-password',
    component: EditPasswordComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'edit-infos',
    component: EditInfosComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'jobalert',
    component: JobalertComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'edit-job',
    component: EditJobalertComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'lost-pass',
    component: LostPasswordComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'auth',
    component: AuthComponent
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
